import * as yup from 'yup';

yup.setLocale(require('./messages/en'));

export default yup;
